import { render, staticRenderFns } from "./ModalReciboPogramacion.vue?vue&type=template&id=124a8e93&"
import script from "./ModalReciboPogramacion.vue?vue&type=script&lang=js&"
export * from "./ModalReciboPogramacion.vue?vue&type=script&lang=js&"
import style0 from "./ModalReciboPogramacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports